<template>
	<div class="container">
		<el-row class="first-row" :gutter="50">
			<el-col :xs="24" :span="16">
				<el-card class="box-card">
					<div class="card-title">欢迎体验百递指数</div>
					<div class="card-subtitle">如您需要开通服务，请联系商务人员</div>
					<el-button type="warning" round @click="goToUdesk">
						联系商务
					</el-button>
				</el-card>
			</el-col>
			<el-col :xs="24" :span="8">
				<el-card class="box-card">
					<div class="card-subtitle">功能权限</div>
					<div class="role-wrap">地区数据：<span :class="{'open':areaOpen}">{{areaOpen?'已开通':'未开通'}}</span></div>
					<div class="role-wrap">线路数据：<span :class="{'open':circuitOpen}">{{circuitOpen?'已开通':'未开通'}}</span>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<el-row class="last-row" :gutter="50">
			<el-col @click.native="toPage(item)" v-for="(item,index) in subRouter" :key="index" :xs="24" :span="8">
				<el-card class="box-card">
					<div>
						<el-icon :class="item.icon"></el-icon>
						<span>{{item.name}}</span>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	// import {
	// 	getUserInfo
	// } from '@/utils/api/user'
	export default {
		data() {
			return {
				subRouter: [{
						name: '我的关注',
						link: '/concern',
						icon: 'el-icon-star-on'
					},
					{
						name: '地区数据分析',
						link: '/area',
						icon: 'el-icon-s-data'
					},
					{
						name: '快递路线分析',
						link: '/circuit',
						icon: 'el-icon-s-flag'
					},
				]
			}
		},
		computed: {
			...mapGetters([
				'token',
			]),
			areaOpen() {
				return this.$HasPermission(['area_module'])
			},
			circuitOpen() {
				return this.$HasPermission(['route_module'])
			}
		},
		mounted() {},
		methods: {
			// 页面跳转（需判断是否有权限）
			toPage({
				link
			}) {
				if (this.token) {
					switch (link) {
						case '/concern':
							this.$router.push(link)
							break;
						case '/area':
							if (this.areaOpen) {
								this.$router.push(link)
							} else {
								this.openConfirm()
							}
							break;
						case '/circuit':
							if (this.circuitOpen) {
								this.$router.push(link)
							} else {
								this.openConfirm()
							}
							break;
						default:
							break;
					}
				} else {
					window.location.href =this.$LoginUrl
				}

			},
			openConfirm(){
				this.$confirm('请联系QQ:2850515747或发邮件到api@kuaidi100.com,我们将竭诚为您服务', '你还没有开通权限', {
					confirmButtonText: '联系商务',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.goToUdesk()
				})
			},
			goToUdesk(){
				window.open(this.$UdeskUrl, '_blank')
			}
			
		}
	}
</script>

<style lang="less">
	.container {
		max-width: 1900px;
		height: 100%;
		font-size: 18px;
		overflow-x: hidden;
		overflow-y: auto;
		margin: auto;
		.first-row {
			margin-bottom: 50px;

			.box-card {
				box-sizing: border-box;

				.el-card__body {
					min-height: 180px;

					.card-title {
						font-size: 24px;
						font-weight: bold;
						margin-bottom: 20px;
					}

					.card-subtitle {
						margin-bottom: 20px;
						font-size: 20px;
						font-weight: bold;
					}

					.el-link {
						color: #fff
					}
				}

				.role-wrap {
					font-size: 16px;
					margin-bottom: 5px;

					>span {
						font-size: 14px;
						color: #999;
					}

					.open {
						color: #00a4ff;
					}
				}
			}
		}

		.last-row {
			.box-card {
				font-weight: 600;
				cursor: pointer;

				&:hover {
					color: #00a4ff;
					transform: translateY(-3px);
					border-top: 2px solid #00a4ff;
					transition: all .2s linear;
				}

				.el-card__body {
					width: 100%;
					min-height: 180px;
					position: relative;
					box-sizing: border-box;


					>div {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						width: 90%;
						text-align: center;

						span {
							font-size: 18px;
							margin-left: 5px;
						}
					}
				}
			}
		}
		@media screen and (max-width: 767px) {
			.box-card {
				margin-bottom: 10px;
			}
		}
	}
</style>
